import { styled, Box, Slider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const DurationSliderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const DurationSlider = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-thumb': {
    color: theme.palette.grey[50],
  },
  '& .MuiSlider-track': {
    color: theme.palette.grey[50],
  },
  '& .MuiSlider-rail': {
    color: theme.palette.grey[600],
  },
  '& .MuiSlider-thumb.Mui-disabled': {
    color: theme.palette.grey[400],
  },
  '&.Mui-disabled .MuiSlider-track': {
    color: theme.palette.grey[400],
  },
}));

export const UpgradeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: theme.spacing(1),
  backgroundColor: theme.palette.grey[800],
  borderRadius: theme.spacing(0.5),
}));

export const UpgradeDescription = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.warning.main,
  marginLeft: theme.spacing(1),
}));

export const UpgradeAction = styled(Link)(({ theme }) => ({
  marginLeft: 'auto',
  textDecoration: 'none',
  padding: 0,
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.common.white,
}));
